<template>
    <v-container fluid>
        <v-expansion-panels v-model="options" multiple class="mb-5">
            <v-expansion-panel>
                <v-expansion-panel-header
                    ><strong>Opções</strong></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                    <v-row>
                        <v-col>
                            <v-select
                                label="Tipo de Parceiro"
                                :items="resellerTypes"
                                item-text="name"
                                item-value="value"
                                v-model="resellerType"
                                clearable
                            ></v-select>
                        </v-col>
                        <v-col>
                            <v-select
                                label="Periodicidade"
                                :items="frequencyOptions"
                                v-model="frequency"
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-col class="pa-0 mb-3">
            <CustomersChart :resellerTypeRefer="resellerType" />
        </v-col>

        <v-col class="pa-0 mb-3">
            <PeriodsChart :resellerTypeRefer="resellerType" />
        </v-col>

        <v-col class="pa-0 mb-3">
            <CancellationsChart :resellerTypeRefer="resellerType" />
        </v-col>

        <v-col class="pa-0 mb-3">
            <ProductPeriodsChart :resellerTypeRefer="resellerType" />
        </v-col>
    </v-container>
</template>

<script>
import CancellationsChart from '@/components/dashboard/CancellationsChart'
import PeriodsChart from '@/components/dashboard/PeriodsChart'
import ProductPeriodsChart from '@/components/dashboard/ProductPeriodsChart'
import CustomersChart from '@/components/dashboard/CustomersChart'

export default {
    components: {
        CancellationsChart,
        PeriodsChart,
        ProductPeriodsChart,
        CustomersChart,
    },

    data: () => ({
        options: [0],
        resellerType: null,
        resellerTypes: [
            { name: 'Parceiro', value: 'partner' },
            { name: 'Revendedor', value: 'reseller' },
        ],
        frequencyOptions: ['Mensal'],
        frequency: 'Mensal',
    }),
}
</script>

<style></style>
